<section class="dosage-validator">
    <mat-card class="dosage-card">
        <mat-card-title>Medication Dosage Validator</mat-card-title>
        <mat-card-subtitle>
            Sandbox route that bypasses the guarded /app shell so you can validate Dosage inputs quickly.
        </mat-card-subtitle>

        <form class="dosage-form" [formGroup]="dosageForm">
            <div class="field-section" formGroupName="dosageTiming">
                <div class="section-header">
                    <h3>Timing</h3>
                    <p>{{ timingHint }}</p>
                </div>
                <div class="field-grid">
                    <mat-form-field appearance="outline">
                        <mat-label>Timing code</mat-label>
                        <mat-select formControlName="timingCode">
                            <mat-option [value]="null">None</mat-option>
                            @for (option of timingCodeOptions; track option.code) {
                            <mat-option [value]="option">
                                {{ option.display }} ({{ option.code }})
                            </mat-option>
                            }
                        </mat-select>
                        <mat-hint>FHIR uses http://terminology.hl7.org/CodeSystem/v3-GTSAbbreviation</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Duration</mat-label>
                        <input matInput type="number" min="0" formControlName="duration" />
                        <mat-hint>Optional numeric length</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Duration unit</mat-label>
                        <mat-select formControlName="durationUnit">
                            <mat-option [value]="null">None</mat-option>
                            @for (unit of durationUnitOptions; track unit.code) {
                            <mat-option [value]="unit.label">{{ unit.label }} ({{ unit.code }})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="field-section" formGroupName="doseAndRateDoseQuantity">
                <div class="section-header">
                    <h3>Dose & Rate</h3>
                    <p>Maps to Dosage.doseAndRate[0].doseQuantity</p>
                </div>
                <div class="field-grid">
                    <mat-form-field appearance="outline">
                        <mat-label>Value</mat-label>
                        <input matInput type="number" min="0" formControlName="value" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Unit</mat-label>
                        <input matInput type="text" formControlName="unit" [placeholder]="quantityUnitHint" />
                    </mat-form-field>
                </div>
            </div>

            <mat-form-field appearance="outline" class="instruction-field">
                <mat-label>Instruction text (optional)</mat-label>
                <textarea matInput rows="3" formControlName="dosageInstruction"></textarea>
                <mat-hint>Populates Dosage.text</mat-hint>
            </mat-form-field>

            <div class="actions">
                <button mat-stroked-button type="button" (click)="loadExample('daily')">
                    <mat-icon fontIcon="medical_information"></mat-icon>
                    Daily example
                </button>
                <button mat-stroked-button type="button" (click)="loadExample('taper')">
                    <mat-icon fontIcon="medication"></mat-icon>
                    Alternate-day example
                </button>
                <button mat-button type="button" (click)="resetForm()">
                    <mat-icon fontIcon="refresh"></mat-icon>
                    Reset
                </button>
            </div>
        </form>
    </mat-card>

    <mat-card class="preview-card">
        <mat-card-title>FHIR Dosage Preview</mat-card-title>
        @if (dosagePreview) {
        <pre>{{ dosagePreview | json }}</pre>
        } @else {
        <p>Add timing or quantity data to materialize a Dosage payload.</p>
        }
    </mat-card>

    <mat-card class="reference-card">
        <mat-card-title>MedicationDispense context</mat-card-title>
        <p>
            <strong>dosageInstruction[]</strong> is only part of the dispense record. The fields below also capture
            what was actually supplied.
        </p>
        <ul>
            @for (field of otherDispenseFields; track field.name) {
            <li><strong>{{ field.name }}</strong> — {{ field.description }}</li>
            }
        </ul>
    </mat-card>
</section>